import { useMemo } from 'react';
import { ArrowDownToLine } from 'lucide-react';
import { Button } from '../../../components/ui/button';
import { useAnalytics } from '../../../core/analytics/useAnalytics';
import { aggregateTransfers } from '../model/transferJobRules';
import { selectOrderedJobs, useTransfersStore } from '../store/transfersStore';
import { useTransfersPanelStore } from '../store/transfersPanelStore';

export function TransfersStatusChip() {
  const jobs = useTransfersStore((state) => state.jobs);
  const order = useTransfersStore((state) => state.order);
  const show = useTransfersPanelStore((state) => state.show);
  const { track } = useAnalytics();
  const ordered = useMemo(() => selectOrderedJobs({ jobs, order }), [jobs, order]);
  const aggregate = useMemo(() => aggregateTransfers(ordered), [ordered]);
  if (ordered.length === 0) return null;

  // U13 (A+B merge): an item of the app status bar (`layout/components/AppStatusBar.tsx`), no longer a floating chip at
  // the window's bottom-left that covered the sidebar footer and a tab's status bar.
  return (
    <Button
      variant="ghost"
      size="xs"
      className="h-5 gap-1.5 px-1.5 text-xs tabular-nums"
      aria-label={`Transfers: ${aggregate.detail}`}
      title={aggregate.detail}
      data-testid="transfers-chip"
      data-active-count={aggregate.activeCount}
      onClick={() => {
        track('ui:transfers_chip_open');
        show('chip');
      }}
    >
      <ArrowDownToLine className="h-3.5 w-3.5" aria-hidden="true" />
      <span data-testid="transfers-chip-label">{aggregate.label}</span>
    </Button>
  );
}
